import { render, staticRenderFns } from "./AdvertisersTableDetailsModalRates.vue?vue&type=template&id=4241ac38&scoped=true"
import script from "./AdvertisersTableDetailsModalRates.vue?vue&type=script&lang=js"
export * from "./AdvertisersTableDetailsModalRates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4241ac38",
  null
  
)

export default component.exports